<template>
  <v-card v-if="!!order" flat id="factor.print">
    <v-card-title>{{ $t("menuOrderFactor.order_invoice") }}</v-card-title>
    <v-card-subtitle>{{ translatedTitle }}</v-card-subtitle>

    <v-row no-gutters>
      <v-col v-for="(item, i) in order.items" :key="i" class="px-2" cols="12">
        <v-card-subtitle class="d-flex align-center justify-space-between py-2">
          {{ translatedProductName(item.product.name) }}

          <div class="d-flex align-center">
            <span class="grey--text me-2"
              >x {{ use_lang(price(item.count)) }}</span
            >
            <div>
              <span class="font-size-h6 font-weight-bold">{{
                use_lang(price(item.product.price))
              }}</span>
              <span class="grey--text ms-1">{{
                $t("menuOrderFactor.currency")
              }}</span>
            </div>
          </div>
        </v-card-subtitle>
        <v-divider class="my-0 mx-4" />
      </v-col>

      <v-col class="px-2" cols="12">
        <v-card-subtitle class="d-flex align-center justify-space-between py-2">
          {{ $t("menuOrderFactor.total") }}

          <div>
            <span style="font-size: 1.1em">{{
              use_lang(price(cartProps.total))
            }}</span>
            <span class="grey--text ms-1">{{
              $t("menuOrderFactor.currency")
            }}</span>
          </div>
        </v-card-subtitle>
      </v-col>

      <v-col class="px-2" cols="12">
        <v-card-subtitle class="d-flex align-center justify-space-between py-2">
          {{ $t("menuOrderFactor.tax") }}

          <div>
            <span style="font-size: 1.1em">{{
              use_lang(price(cartProps.vat))
            }}</span>
            <span class="grey--text ms-1">{{
              $t("menuOrderFactor.currency")
            }}</span>
          </div>
        </v-card-subtitle>
      </v-col>

      <v-col class="px-2" cols="12">
        <v-card-subtitle class="d-flex align-center justify-space-between py-2">
          {{ $t("menuOrderFactor.shipping_cost") }}

          <div>
            <span style="font-size: 1.1em">{{ use_lang(price(110000)) }}</span>
            <span class="grey--text ms-1">{{
              $t("menuOrderFactor.currency")
            }}</span>
          </div>
        </v-card-subtitle>
      </v-col>

      <v-col v-if="cartProps.packing_price" class="px-2" cols="12">
        <v-card-subtitle class="d-flex align-center justify-space-between py-2">
          {{ $t("menuOrderFactor.packing_cost") }}

          <div>
            <span style="font-size: 1.1em">{{
              use_lang(price(cartProps.packing_price))
            }}</span>
            <span class="grey--text ms-1">{{
              $t("menuOrderFactor.currency")
            }}</span>
          </div>
        </v-card-subtitle>
      </v-col>

      <v-col v-if="cartProps.discount" class="px-2" cols="12">
        <v-card-subtitle class="d-flex align-center justify-space-between py-2">
          <span class="font-weight-bold font-size-h6 blue--text">{{
            $t("menuOrderFactor.discount")
          }}</span>

          <div>
            <span style="font-size: 1.1em">{{
              use_lang(price(cartProps.discount))
            }}</span>
            <span class="grey--text ms-1">{{
              $t("menuOrderFactor.currency")
            }}</span>
          </div>
        </v-card-subtitle>
      </v-col>

      <v-col class="px-2" cols="12">
        <v-divider class="my-0 mx-4" />
        <v-card-subtitle class="d-flex align-center justify-space-between py-2">
          <span class="font-size-h6 font-weight-bold">{{
            $t("menuOrderFactor.final_total")
          }}</span>

          <div>
            <span style="font-size: 1.1em">{{
              use_lang(price(cartProps.final))
            }}</span>
            <span class="grey--text ms-1">{{
              $t("menuOrderFactor.currency")
            }}</span>
          </div>
        </v-card-subtitle>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "menuOrderFactor",
  props: {
    info: Object,
    order: Object,
  },
  computed: {
    cartProps() {
      if (!this.order) return {};

      let obj = {
        count: 0,
        total: 0,
        final: 0,
        discount: 0,
        vat: 0,
      };

      this.order.items?.forEach((v) => {
        obj.count += v.count;
        obj.total += v.product.price * v.count;
        obj.final += this.withDiscount(
          v.product.price * v.count,
          v.product.discount_amount
        );
        obj.discount += this.discountPrice(
          v.product.price * v.count,
          v.product.discount_amount
        );
      });

      obj.vat = Math.floor(((obj.total - obj.discount) * 10) / 100);
      obj.final += obj.vat;

      switch (this.order.shipping_type) {
        case "place":
        case "courier": {
          let pp = 0;
          this.order.items.forEach((item) => {
            pp += !!item.packing_price ? item.packing_price * item.count : 0;
          });
          if (!!pp) {
            obj.packing_price = pp;
            obj.final += pp;
          }
          break;
        }
      }

      return obj;
    },
    translatedTitle() {
      return this.info.title;
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    withDiscount(price, discount) {
      if (!!discount) {
        let dis = Math.floor((price * discount) / 100);
        return Number(price - dis);
      }
      return Number(price);
    },
    discountPrice(price, discount) {
      if (!!discount) {
        return Math.floor((price * discount) / 100);
      }
      return Number(0);
    },
    translatedProductName(name) {
      // Assume product.name is a translation key
      return name;
    },
  },
};
</script>

<style scoped></style>
